module.exports = __webpack_public_path__ + "img/detail-clock.0b19cbf0.svg";